import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (membershipId: string, password: string) => void;
};

export const AppLinkageForm: React.FC<Props> = ({ handleSubmit }) => {
  const schema = useMemo(() => {
    return z.object({
      membershipId: z.string().min(1),
      password: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    any,
    undefined
  > | null>(null);

  return (
    <FormContainer>
      <FormTemplate
        schema={schema}
        setMethods={setMethods}
        defaultValues={{
          membershipId: "",
          password: "",
        }}
        onSubmit={({ membershipId, password }) =>
          handleSubmit(membershipId, password)
        }
      >
        <Wrapper>
          <InputContainer>
            <Input
              name="membershipId"
              label="アプリ会員ID"
              placeholder="アプリ会員IDを入力"
              dataWovnIgnore={true}
            />
          </InputContainer>
          <InputContainer>
            <Input
              name="password"
              type="password"
              label="パスワード"
              placeholder="パスワードを入力"
              dataWovnIgnore={true}
            />
          </InputContainer>
        </Wrapper>

        <ButtonWrapper>
          <Button
            type="submit"
            text="クーポン取得"
            btnStyle="primary"
            rounded="md"
          />
        </ButtonWrapper>
      </FormTemplate>
    </FormContainer>
  );
};

const FormContainer = styled.div`
  width: 100%;
`;

const InputContainer = styled.div`
  margin-bottom: 20px;
`;

const Wrapper = styled.div`
  overflow: hidden;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 12px;
  button {
    font-family: "Hiragino Sans";
    font-weight: 600;
    line-height: 1em;
    height: auto;
    width: 100%;
  }
`;
